const DEFAULT_DELAY_MS = 500;
/** Gaps shorter than this belong to the same wait and must not re-arm the delay. */
const DEFAULT_GRACE_MS = 150;

const createLoadingOverlayStore = (delayMs = DEFAULT_DELAY_MS, graceMs = DEFAULT_GRACE_MS) => {
  let visible = false;
  let busy = false;
  let showTimer: ReturnType<typeof setTimeout> | undefined;
  let hideTimer: ReturnType<typeof setTimeout> | undefined;
  const listeners = new Set<() => void>();

  const setVisible = (next: boolean) => {
    if (visible === next) return;
    visible = next;
    for (const listener of listeners) listener();
  };

  const clearShow = () => {
    clearTimeout(showTimer);
    showTimer = undefined;
  };

  return {
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    getSnapshot: (): boolean => visible,
    setBusy: (next: boolean) => {
      if (busy === next) return;
      busy = next;

      if (busy) {
        clearTimeout(hideTimer);
        hideTimer = undefined;
        if (visible || showTimer !== undefined) return;
        showTimer = setTimeout(() => {
          showTimer = undefined;
          setVisible(true);
        }, delayMs);
        return;
      }

      hideTimer = setTimeout(() => {
        hideTimer = undefined;
        clearShow();
        setVisible(false);
      }, graceMs);
    },
  };
};

type LoadingOverlayStore = ReturnType<typeof createLoadingOverlayStore>;

export { createLoadingOverlayStore, DEFAULT_DELAY_MS, DEFAULT_GRACE_MS };
export type { LoadingOverlayStore };
